import styled from 'styled-components'
import Layout from '..'

const { Content } = Layout

export default styled(Content)`
  overflow: auto;
  padding: ${({ theme }) => theme.spacing.spacing24}px;
  color: inherit;
`
